import { Component, ViewChild, ViewContainerRef, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-container',
    template: ` <ng-template #dynamic></ng-template> `,
    standalone: false
})
export class ContainerComponent implements OnDestroy {
  ngOnDestroy(): void {
    // console.log('ContainerComponent ngOnDestroy');
  }
  private componentRef: any;
  currentComponent;

  @ViewChild('dynamic', {
    static: true,
    read: ViewContainerRef,
  })
  viewContainerRef: ViewContainerRef;

  constructor() {}

  insert(component) {
    this.currentComponent = component;
    this.viewContainerRef.insert(component.hostView);
  }

  clean() {
    if (this.viewContainerRef.length === 1) {
      this.viewContainerRef.detach(0);
    }
  }
}
